// Formats a "YYYY-MM-DD" string as "MM/DD/YYYY" without timezone conversion.
export const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("T")[0].split("-");
  return `${month}/${day}/${year}`;
};
